<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { Websocket } from "@/mixins/socket";
export default {
  mixins:[Websocket],
  name: 'App',
  mounted() {
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss">
.notice-message.el-notification {
  padding: 0 !important;
  width: auto !important;
}
.notice-message .el-notification__group {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.notice-message .el-notification__content {
  margin-top: 0 !important;
}
.notice-message .el-notification__closeBtn {
  top: 10px !important;
}
#app {
  min-width: 1200px;
}
</style>
